import { stringifyQueryStringObject } from "../../../../services/parseQueryString";
import {
  animateNavigationToNewPath,
  getFilteredQueryString,
  setupLoanRoute
} from "@utils/helpers/navigators";

export const createFormStepNavigator = (stepPathname, stepNumber) => {
  const shouldRouteBeActive = (loanFormState, pathname) => {
    const { step } = loanFormState;

    if (step > 4) {
      return false;
    }

    return pathname !== stepPathname && step === stepNumber;
  };
  
  const navigateTo = (navigate, loanFormState, queryString = {}) => {
    const { accountExternalId } = loanFormState;

    if(!!accountExternalId) {
      queryString.id = `loanapplication-${accountExternalId}`;
    }
    const filteredQueryString = getFilteredQueryString(queryString);
    const search = stringifyQueryStringObject(filteredQueryString);
    
    const newPath = stepPathname + search;
    
    animateNavigationToNewPath(navigate, newPath);
  };

  return setupLoanRoute({shouldRouteBeActive, navigateTo});
}